/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import useStockRemovals from "./useStockRemovals";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../assets/svgIcons";

const StockRemovals = () => {
  const [selectedDraft, setSelectedDraft] = useState(null);
  const {
    storeList,
    isLoadingRequests,
    stockRemovals,
    metaDetails,
    isRemoveStock,
    search,
    setIsRemoveStock,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
    startDate,
    endDate,
    stockRemovalStatusTabs,
    pendingCount,
    handleFetchRequests,
  } = useStockRemovals();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Stock Removals"
      description="View and manage stock removal requests"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Stock Removals</h4>
            <p>
              Review, approve, and track evidence-based stock removal requests.
            </p>
          </div>

          {/* Top Status Tabs Filter */}
          <div className={globalStyles.rowNavigations}>
            {stockRemovalStatusTabs?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  (search.get("status") || "ALL") === (item?.value || "ALL")
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() =>
                  filterByKey(
                    "status",
                    !item?.value || item?.value === "ALL" ? null : item?.value,
                  )
                }
              >
                {item?.label}{" "}
                {item?.value === "REVIEW" && pendingCount > 0 ? (
                  <span className={`ml-1 ${globalStyles.noOfPends}`}>
                    {pendingCount}
                  </span>
                ) : null}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total || 0} Stock Removal Requests</p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_remove_products"
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() => {
                  setSelectedDraft(null);
                  setIsRemoveStock(true);
                }}
              >
                <PlusIcon className="mr-1" /> Remove Stock
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* Table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by request ID"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <div className="ml-auto" style={{ width: "160px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All stores",
                      id: null,
                    },
                    ...storeList,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "All stores"
                  }
                  floatError={false}
                  isSearchable={false}
                />
              </div>

              <primaryComponents.DateRangeInput
                startDate={startDate}
                endDate={endDate}
                onChange={filterByDate}
              />
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isLoadingRequests}
              classNames="mt-5"
            >
              <secondaryComponents.StockRemovalsTable
                stockRemovals={stockRemovals}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
                refetch={handleFetchRequests}
                onContinueDraft={(draft) => {
                  setSelectedDraft(draft);
                  setIsRemoveStock(true);
                }}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          {/* Remove Stock Sidebar Modal */}
          <secondaryComponents.SideModal
            width={650}
            isActive={isRemoveStock}
            closeModal={() => {
              setIsRemoveStock(false);
              setSelectedDraft(null);
            }}
          >
            <secondaryComponents.DeleteStockWidget
              draftRequest={selectedDraft}
              closeWidget={() => {
                setIsRemoveStock(false);
                setSelectedDraft(null);
                handleFetchRequests();
              }}
            />
          </secondaryComponents.SideModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default StockRemovals;
